import { createSelector } from 'reselect';
import _get from 'lodash/get';
import _intersection from 'lodash/intersection';

import { createOption } from 'react-redux-app/lib/modules/form/utils/multiSelect';

import { CAMPAIGN_STATUS__ACTIVE } from '../../campaign/constants';
import { translationLangsOrder } from '../constants';

import { getCurrentSitePromotedSite, getCurrentSiteTemplateId } from '../../site/selectors';
import { getPromotedSites } from '../../affiliateTools/selectors';


const getSiteBuilderSettings = state => state.siteBuilder;
export const getLastCreatedSiteId = state => getSiteBuilderSettings(state).lastCreatedSiteId;

export const getCreatePreparation = state => getSiteBuilderSettings(state).createPreparation;
export const getCampaigns = state => getCreatePreparation(state).campaigns;

export const getActiveCampaigns = createSelector(
  getCampaigns,
  campaigns => campaigns.filter(campaign => campaign.status === CAMPAIGN_STATUS__ACTIVE)
);

export const getPromotedSiteToWlTemplateToLangsMap = state => (
  getCreatePreparation(state).promotedSiteToWlTemplateToLangsMap
);

const getAllPromotedSiteToWlTemplateToLangs = state => (
  getSiteBuilderSettings(state).allPromotedSiteToWlTemplateToLangs
);

export const getCurrentSiteAvailableLangs = createSelector(
  getCurrentSitePromotedSite,
  getCurrentSiteTemplateId,
  getAllPromotedSiteToWlTemplateToLangs,
  (promotedSite, templateId, templateToLangs) => {
    if (!promotedSite || !templateId) {
      return null;
    }
    return _intersection(translationLangsOrder, _get(templateToLangs, [promotedSite, templateId]));
  }
);

export const getPromotedSiteList = createSelector(
  getPromotedSiteToWlTemplateToLangsMap,
  promotedSiteToWlTemplateToLangsMap => (
    promotedSiteToWlTemplateToLangsMap ? Object.keys(promotedSiteToWlTemplateToLangsMap) : null
  )
);

export const getPromotedSitesOptions = createSelector(
  getPromotedSiteList,
  getPromotedSites,
  (promotedSiteList, sites) => (
    promotedSiteList
      ? promotedSiteList.map(site => createOption(sites[site].name, site))
      : null
  )
);

export const getCurrentSiteTemplateLangs = createSelector(
  getCurrentSitePromotedSite,
  getCurrentSiteTemplateId,
  getPromotedSiteToWlTemplateToLangsMap,
  (promotedSite, templateId, templateToLangs) => _get(templateToLangs, [promotedSite, templateId])
);
const getMaxSitesNumber = state => getCreatePreparation(state).maxSitesNumber;
const getSitesNumber = state => getCreatePreparation(state).sitesNumber;
export const getIsMaxSiteNumberReached = state => (
  getSitesNumber(state) >= getMaxSitesNumber(state)
);
